
contactForm = {
	openModal:function(target){
        $('.contactFormContent').hide();
        if($('.contactFormContent.contactFormContent-'+target).length>0){
        	 $('.contactFormContent.contactFormContent-'+target).show();
        	$('#contactFormModal').modal('show');    
        }
           

    },
    toggleModalView:function(target){
        $('.contactFormContent').hide();
        $('.contactFormContent.contactFormContent-'+target).show();
    }
} 

 
